import $ from 'jquery';
import defaults from 'lodash/defaults';
export const LOGOUT_URL = '/r/ajax/SignOut.jsp?mobile=true';
export const METHOD = 'POST';

export default function logout(options) {
  try {
    if(typeof(crdl) != 'undefined' && crdl != null) {
        crdl('forget');
    }
  } catch(e) {
      console.log(e);
  }
  options = options || {};
  defaults(options, {
    reloadFunc: function() { 
        window.location.reload();
    }
  });
  return $.ajax({
      type: METHOD,
      url: LOGOUT_URL
    })
    .then(function(data) {
      var obj = $.parseJSON(data);
      if (obj.success) {
          sessionStorage.removeItem('womens-data'); //clear nav cache
          sessionStorage.removeItem('mens-data');
          options.reloadFunc();
      }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/logout.js